import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {Checkbox} from '@/web-components';
import {NOVA_INVOCATION_COLUMN_WIDTH} from '../../../forecast-app/shared/components/nova-invocation/styleTokens';
class TaskTableHeader extends Component {
	toggleTasks(selected) {
		if (selected) {
			this.props.onDeselectAllTasks && this.props.onDeselectAllTasks();
		} else {
			this.props.onSelectAllTasks && this.props.onSelectAllTasks();
		}
	}
	render() {
		const {formatMessage} = this.props.intl;
		const height = this.props.height != null ? this.props.height : '';
		let taskIdElemEnabled = !!this.props.availableColumns.find(
			col => col.checked && col.name === 'task-id' && !col.independant
		);
		// The Nova column has no sortable header of its own - it is a label over a control - so it is
		// found the same way the selector is rather than taking part in the column loop below.
		const novaElemEnabled = !!this.props.availableColumns.find(col => col.checked && col.name === 'nova');
		const novaWidth = novaElemEnabled ? NOVA_INVOCATION_COLUMN_WIDTH : 0;
		let selectorElemEnabled = !!this.props.availableColumns.find(
			col => col.checked && col.name === 'selector' && !col.independant
		);
		const content = (
			<div
				data-cy="task-table-header-v3"
				className={'task-table-header-v3' + (this.props.noPaddingLeft ? ' no-left' : '')}
				style={{maxHeight: height, height: height, minHeight: height}}
			>
				{this.props.availableColumns.map((col, index) => {
					const name = col.translationId ? formatMessage({id: col.translationId}).toUpperCase() : '';
					const title = col.title ? formatMessage({id: col.title}) : '';
					const sortable = col.sortable && this.props.onSortValueChange;
					const sortName = sortable
						? ' sortable ' +
						  (this.props.sortValue === col.name + '-asc'
								? 'ascending'
								: this.props.sortValue === col.name + '-dsc'
								? 'descending'
								: '')
						: '';
					if (col.checked || col.maintainSpace) {
						if (col.notAnElem) {
							return null;
						}
						// Drawn inside the task-name cell's leading cluster below, beside the selector and
						// the task id, so it must not also take a cell of its own here. It carries no
						// maxWidth, so that cell would pick up the growable class and - being empty - eat
						// every spare pixel in the header, pushing each heading right of the column it
						// names.
						if (col.name === 'nova') {
							return null;
						}
						if (col.name === 'selector') {
							return (
								<div
									key={index}
									style={{
										maxWidth: col.maxWidth,
										minWidth: col.minWidth,
										textAlign: col.align,
										paddingLeft: 16,
									}}
									className={'row-' + col.name}
								></div>
							);
						}
						if (col.name === 'price' && !this.props.hasFinancialAccess) {
							return null;
						}
						if (col.name === 'task-id') {
							return col.independant ? (
								<div
									key={index}
									style={{
										maxWidth: col.maxWidth,
										minWidth: col.minWidth,
										textAlign: col.align,
										paddingLeft: 16,
									}}
									className={'row-' + col.name + (!col.maxWidth ? ' growable' : '') + sortName}
									onClick={
										sortable
											? this.props.onSortValueChange.bind(
													this,
													this.props.sortValue === col.name + '-dsc'
														? 'updated-at'
														: col.name +
																(this.props.sortValue === col.name + '-asc' ? '-dsc' : '-asc')
											  )
											: null
									}
									title={title}
								>
									{name}
									{sortable ? <span>&nbsp;&nbsp;</span> : null}
								</div>
							) : null;
						}
						if (col.name === 'task-name') {
							return (
								<div
									key={'task-group-' + index}
									className={
										'task-group' +
										(!col.maxWidth ? ' growable' : '') +
										(this.props.showProjectIndicator ? ' not-first' : '')
									}
									style={{
										// Widened by exactly what the row widens its own leading cell by. Short of
										// that the cluster cannot hold the checkbox, the label and the task heading
										// at once, and the checkbox cell - the only one here that can give way -
										// shrinks, carrying every label after it left of the column it names.
										maxWidth: this.props.taskCellMaxWidth + novaWidth,
										minWidth: this.props.taskCellMaxWidth + novaWidth,
										textAlign: col.align,
									}}
								>
									{selectorElemEnabled ? (
										<div key={'selector-' + index} className={'task-selector-row-elem'}>
											{!(this.props.groupByPerson || this.props.groupByRole || this.props.isEmpty) && (
												<Checkbox
													checked={this.props.allTasksSelected}
													onClick={this.toggleTasks.bind(this, this.props.allTasksSelected)}
												/>
											)}
										</div>
									) : null}
									{novaElemEnabled ? (
										<div
											key={'nova-' + index}
											className={'nova-row-elem'}
											// minWidth as well as width: this cluster is sized to the task cell, so a
											// long task heading would otherwise shrink the label out from over its
											// column.
											style={{
												width: NOVA_INVOCATION_COLUMN_WIDTH,
												minWidth: NOVA_INVOCATION_COLUMN_WIDTH,
											}}
										>
											{formatMessage({id: 'nova_invocation.column.header'}).toUpperCase()}
										</div>
									) : null}
									{taskIdElemEnabled ? (
										<div
											key={'task-id-' + index}
											className={
												'task-id-row-elem' +
												(sortable
													? ' sortable ' +
													  (this.props.sortValue === 'task-id-asc'
															? 'ascending'
															: this.props.sortValue === 'task-id-dsc'
															? 'descending'
															: '')
													: '')
											}
											onClick={
												sortable
													? this.props.onSortValueChange.bind(
															this,
															this.props.sortValue === 'task-id-dsc'
																? 'updated-at'
																: 'task-id' +
																		(this.props.sortValue === 'task-id-asc'
																			? '-dsc'
																			: '-asc')
													  )
													: null
											}
											title={title}
										>
											{formatMessage({id: 'project_board.card_details_selector_task_id'}).toUpperCase()}
											{sortable ? <span>&nbsp;&nbsp;</span> : null}
										</div>
									) : null}
									<div
										key={'task-name-' + index}
										className={'row-' + col.name + sortName}
										onClick={
											sortable
												? this.props.onSortValueChange.bind(
														this,
														this.props.sortValue === col.name + '-dsc'
															? 'updated-at'
															: col.name +
																	(this.props.sortValue === col.name + '-asc'
																		? '-dsc'
																		: '-asc')
												  )
												: null
										}
										title={title}
									>
										{col.name === 'controls'
											? ''
											: col.name === 'done-percentage'
											? formatMessage({id: 'common.assigned'})
											: name}
										{sortable ? <span>&nbsp;&nbsp;</span> : null}
									</div>
								</div>
							);
						}
						if (col.name === 'harvest') {
							return this.props.harvestEnabled ? (
								<div
									key={index}
									style={{
										maxWidth: col.maxWidth,
										minWidth: col.minWidth,
										textAlign: col.align,
									}}
									className={'row-' + col.name + (!col.maxWidth ? ' growable' : '')}
									title={title}
								>
									{name}
									{sortable ? <span>&nbsp;&nbsp;</span> : null}
								</div>
							) : null;
						}
						return col.multiLine ? (
							<div
								key={index}
								style={{maxWidth: col.maxWidth, minWidth: col.minWidth, textAlign: col.align}}
								className={'row-' + col.name + (!col.maxWidth ? ' growable' : '')}
							>
								<div className={'multiline-table-header'}>
									<div className={'text-line-1'}>{name.split(' ')[0]}</div>
									<div className={'text-line-2'}>{name.split(' ')[1]}</div>
								</div>
							</div>
						) : (
							<div
								key={index}
								style={{
									maxWidth: col.maxWidth,
									minWidth: col.minWidth,
									textAlign: col.align,
									paddingRight: col.paddingRight ? col.paddingRight : null,
								}}
								className={'row-' + col.name + (!col.maxWidth ? ' growable' : '') + sortName}
								onClick={
									sortable
										? this.props.onSortValueChange.bind(
												this,
												this.props.sortValue === col.name + '-dsc'
													? 'updated-at'
													: col.name + (this.props.sortValue === col.name + '-asc' ? '-dsc' : '-asc')
										  )
										: null
								}
								title={title}
							>
								{!col.checked && col.maintainSpace
									? ''
									: col.name.includes('chip') || col.name === 'controls' || col.hide
									? ''
									: name}
								{sortable ? <span>&nbsp;&nbsp;</span> : null}
							</div>
						);
					} else return null;
				})}
			</div>
		);
		return this.props.withMargin ? <div className={'task-table-header-v3-margin-wrapper'}>{content}</div> : content;
	}
}

TaskTableHeader.propTypes = {
	hasFinancialAccess: PropTypes.bool.isRequired,
};

export default injectIntl(TaskTableHeader);
